
document.addEventListener('DOMContentLoaded', () => {
  // Your JavaScript code here
  const button = document.querySelector('.single-shop-the-look-button.button.outline');

  if (button) {
    button.addEventListener('click', () => {
      const targetSelector = button.getAttribute('data-target');
      const drawer = document.querySelector(targetSelector);

      if (drawer) {
        document.body.classList.add('open-cc');
        drawer.classList.add('active');
      } else {
      }
    });
  }
});


/**
 *  @class
 *  @function ViewProducts
 */
if (!customElements.get('view-products')) {
  class ViewProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.drawer = document.querySelector(this.dataset.target);
      // Ensure the button is listening for click events
      this.addEventListener('click', () => {
        this.setupEventListener();
      });
    }

    setupEventListener() {
      document.body.classList.add('open-cc');
      if (this.drawer) {
        this.drawer.classList.add('active');
      } else {
      }
    }
  }
  customElements.define('view-products', ViewProducts);
}
